var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLayers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.33333 9.8125L2.31836 8.49017C1.70529 8.08785 1.71938 7.18438 2.3447 6.80137L10.4777 1.81992C10.7982 1.62359 11.2018 1.62359 11.5223 1.81992L19.6553 6.80137C20.2806 7.18438 20.2947 8.08785 19.6816 8.49017L17.6667 9.8125M4.33333 9.8125L2.33178 11.126C1.71539 11.5305 1.73374 12.4402 2.36594 12.8196L3.91667 13.75M4.33333 9.8125L10.4915 13.4496C10.8052 13.6349 11.1948 13.6349 11.5085 13.4496L17.6667 9.8125M3.91667 13.75L1.99585 15.4787C1.49889 15.926 1.57236 16.7256 2.1425 17.0748L10.4777 22.1801C10.7982 22.3764 11.2018 22.3764 11.5223 22.1801L19.8575 17.0748C20.4276 16.7256 20.5011 15.926 20.0041 15.4787L18.0833 13.75M3.91667 13.75L10.4745 17.8004C10.7966 17.9994 11.2034 17.9994 11.5255 17.8004L18.0833 13.75M18.0833 13.75L19.6341 12.8196C20.2663 12.4402 20.2846 11.5305 19.6682 11.126L17.6667 9.8125",
    stroke: "#3D3B3B",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayers);
export default __webpack_public_path__ + "static/media/layers.080a17e34a0c530bb41f4ec6d3402c61.svg";
export { ForwardRef as ReactComponent };